var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M37.4411 39.9712C38.8035 41.7606 38.8035 44.2394 37.4411 46.0288L9.16488 83.1689C6.26523 86.9775 0.186634 84.9269 0.186634 80.1401L0.186634 5.85993C0.186634 1.07313 6.26522 -0.977468 9.16487 2.83114L37.4411 39.9712Z"}));
}

RightArrow.defaultProps = {"width":"39","height":"86","viewBox":"0 0 39 86","fill":"none"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
